import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-397d46d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M40 20.1218C40 9.00766 31.0469 0 20 0C8.95312 0 0 9.00766 0 20.1218C0 30.167 7.3125 38.4909 16.875 40V25.9383H11.7969V20.1218H16.875V15.6887C16.875 10.6465 19.8594 7.86009 24.4297 7.86009C26.6172 7.86009 28.9062 8.25309 28.9062 8.25309V13.205H26.3828C23.8984 13.205 23.125 14.7573 23.125 16.349V20.1218H28.6719L27.7852 25.9383H23.125V40C32.6875 38.4909 40 30.167 40 20.1218Z" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "icon-facebook",
    width: _ctx.px,
    height: _ctx.px,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}